import { render } from "./QuizResults.vue?vue&type=template&id=2ed6b94c"
import script from "./QuizResults.vue?vue&type=script&lang=js"
export * from "./QuizResults.vue?vue&type=script&lang=js"

import "./QuizResults.vue?vue&type=style&index=0&id=2ed6b94c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__